<script setup>
import { computed, ref, watch } from 'vue'
import * as courseApi from '@/api/course'

const props = defineProps({
  // 不传则组件内部自管理显隐；传入 v-model 时由父组件控制
  modelValue: {
    type: Boolean,
    default: undefined
  },
  // 课程详情页获赠信息
  giveProduct: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'close', 'receive'])

const innerVisible = ref(true)
const isControlled = computed(() => props.modelValue !== undefined)
const dismissed = ref(false)
const hasObtained = ref(false)

const shouldShowByStatus = computed(() => {
  return props.giveProduct && Number(props.giveProduct.giveProductStatus) === 1
})

const visible = computed(() => {
  const base = isControlled.value ? props.modelValue : innerVisible.value
  return Boolean(base && shouldShowByStatus.value && !dismissed.value)
})

const isEbook = computed(() => Number(props.giveProduct?.giveProductType) === 1)
const isVip = computed(() => Number(props.giveProduct?.giveProductType) === 2)

const giftName = computed(() => props.giveProduct?.giveProductName || '')
const giftPriceText = computed(() => {
  const v = props.giveProduct?.giveProductPrice
  const cents = Number(v)
  if (!Number.isFinite(cents)) return ''
  const yuan = cents / 100
  return `¥${yuan.toFixed(2)}`
})

const giftDescribeText = computed(() => {
  if (!giftName.value) return '恭喜您，获得赠品'
  if (isEbook.value) return `恭喜您，获赠《${giftName.value}》一本`
  if (isVip.value) return `恭喜您，获赠${giftName.value}`
  return `恭喜您，获赠${giftName.value}`
})

const giftImgSrc = computed(() => {
  if (isVip.value) {
    return new URL('@/assets/images/cc_vip_coupon.png', import.meta.url).href
  }
  if (isEbook.value && props.giveProduct?.goodsImage) {
    return props.giveProduct.goodsImage
  }
  // 默认券图
  return new URL('@/assets/images/plus_coupon.png', import.meta.url).href
})

watch(
  () => props.giveProduct?.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      dismissed.value = false
      innerVisible.value = true
      hasObtained.value = false
    }
  }
)

function closeDialog() {
  if (isControlled.value) {
    emit('update:modelValue', false)
  } else {
    innerVisible.value = false
  }
  dismissed.value = true
  emit('close')
}

async function handleReceive() {
  const giveProduct = props.giveProduct
  if (!giveProduct) return

  try {
    // 领取卡券 / 赠品
    const res = await courseApi.obtainGiveProduct({
      cardCouponNo: giveProduct.cardCouponNo,
      stuGiveProductId: giveProduct.id
    })

    if (res && res.resCode === 200) {
      hasObtained.value = true
      emit('receive', giveProduct)
    }
  } catch (e) {
    // 领取失败静默处理，保留弹窗
  }
}

function handleView() {
  const giveProduct = props.giveProduct
  if (!giveProduct) return

  if (isEbook.value) {
    const base = process.env.VUE_APP_YCT_EBOOK_URL
    console.log(base,12333)
    const strEbookId = giveProduct.strEbookId
    if (!base || !strEbookId) return
    const url = `${String(base).replace(/\/$/, '')}/detail?ebookId=${strEbookId}`
    console.log(url,12333)
    window.open(url, '_blank')
    return
  }

  if (isVip.value) {
    const url = process.env.VUE_APP_CHAT_URL
    if (!url) return
    window.open(url, '_blank')
  }
}
</script>

<template>
  <!-- 仅保留样式骨架：你可以在这里重写结构 -->
  <div class="receive_dialog" v-if="visible">
    <!-- 保留图片引用（不影响布局；确保打包时能收集到资源） -->
    <div style="position: absolute; width: 0; height: 0; overflow: hidden;">
      <img src="@/assets/images/cc_vip_coupon.png" alt="">
      <img src="@/assets/images/plus_coupon.png" alt="">
      <img src="@/assets/images/vip_coupon.png" alt="">
      <img src="@/assets/images/svip_coupon.png" alt="">
      <img src="@/assets/images/yct+yzb.png" alt="">
      <img src="@/assets/images/yct+cc.png" alt="">
      <img src="@/assets/images/yct+yzb+cc.png" alt="">
    </div>
    <div class="receive_center receive_center_single">
      <div class="gift_describe">
        <h3>{{ giftDescribeText }}</h3>
      </div>
      <div class="gift_image_wrap">
        <div class="img_center" :class="{ ebook_gift: isEbook }">
          <img :src="giftImgSrc" class="goods_image" alt="">
        </div>
        <div class="gift_info">
          <h3 class="gift_title">{{ isEbook ? `《${giftName}》` : giftName }}</h3>
          <p class="price" v-if="giftPriceText">价值：{{ giftPriceText }}</p>
        </div>
        <div class="draw_status" v-if="hasObtained">
          <img class="status_img" src="@/assets/images/draw.png" alt="">
        </div>
      </div>
      <div class="base_map">
        <div class="draw_btn">
          <div class="btn_center" v-if="!hasObtained" @click="handleReceive">领取</div>
          <div class="btn_center" v-else @click="handleView">去查看</div>
        </div>
        <div class="tip_txt_wrap">
            <p class="tip_txt">请在30天内领取，逾期作废。领取方式：易采通-我的-卡券</p>
            <p class="tip_txt">易采通网址：www.ycait.com</p>
        </div>

      </div>
      <div class="close_wrap">
        <i class="iconfont iconguanbi close" @click="closeDialog"></i>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.receive_dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 1000000;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;
  .receive_center {
    position: absolute;
    background: linear-gradient(63deg, #fed2a8 0%, #f7e3c6 100%);
    border-radius: 10px;
    left: 0;
    right: 0;
    top: 100px;
    margin: auto;
  }
    .receive_center_single {
    width: 368px;
    height: 324px;
    padding: 20px 16px;
    .gift_describe {
      font-weight: bold;
      font-size: 16px;
      padding: 0 6px;
      color: #696767;
      line-height: 36px;
      display: flex;
      align-items: center;
      height: 64px;
      h3 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
      }
    }
    .gift_image_wrap {
      width: 368px;
      height: 140px;
      background: linear-gradient(-9deg, #1e1e1e, #363634, #1e1e1e);
      box-shadow: 0px 0px 18px 0px rgba(235, 107, 101, 0.2);
      overflow: hidden;
      border-radius: 10px;
      margin-top: 20px;
      .draw_status {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.3);
        z-index: 1;
        border-radius: 10px;
        .status_img {
          width: 134px;
          position: absolute;
          right: 30px;
          top: 120px;
        }
      }
      .img_center {
        width: 152px;
        height: 114px;
        background: #393939;
        border-radius: 8px;
        margin: 12px;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        img {
          display: inline-block;
          width: 100%;
        }
      }
      .video_gift {
        .goods_image {
          width: 100%;
          height: 100%;
        }
      }
      .ebook_gift {
        text-align: center;
        .goods_image {
          height: 100px;
          width: auto;
          max-width: 100%;
          margin-top: 7px;
        }
      }
      .vip_gift {
        text-align: center;
        .goods_image {
          height: 100px;
          margin-top: 8px;
        }
      }
      .gift_info {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        width: 172px;
        .gift_title {
          font-weight: 400;
          font-size: 16px;
          color: #fff5e0;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .price {
          font-weight: 500;
          font-size: 16px;
          color: #fd5a52;
          margin-top: 16px;
        }
      }
    }
    .base_map {
      position: absolute;
      bottom: 0;
      background-image: url('@/assets/images/baseMap.png');
      background-size: cover;
      width: 400px;
      height: 134px;
      left: 0px;
      z-index: 2;
      border-radius: 0 0 10px 10px;
      .draw_btn {
        margin-top: 50px;
        text-align: center;
        .btn_center {
          display: inline-block;
          min-width: 160px;
          height: 32px;
          padding: 0 20px;
          background: linear-gradient(0deg, #ee6b36 0%, #f3ae57 99%);
          border-radius: 20px;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          line-height: 32px;
          margin: 0 auto;
          cursor: pointer;
          transition: all 0.3s;
          &:hover {
            opacity: 0.6;
          }
        }
        .error_btn {
          background: #cccccc;
          color: #ffffff;
        }
      }
      .tip_txt_wrap{
        margin-top: 10px;
        .tip_txt {
        font-weight: 400;
        font-size: 12px;
        color: #7d7d7d;
        text-align: center;
        line-height: 16px;
      }
      }

    }
    .close_wrap {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -80px;
      text-align: center;
      .close {
        font-size: 34px;
        color: #ffffff;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
  .receive_center_multiple {
    width: 436px;
    .gift_describe {
      font-weight: bold;
      font-size: 19px;
      color: #2a2a28;
      display: flex;
      align-items: center;
      height: 56px;
      margin: 26px 16px 0 16px;
      h3 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
    .gift_swiper_wrap {
      width: 396px;
      height: 466px;
      background: linear-gradient(0deg, #1e1e1e 0%, #343432 47%, #1e1e1e 100%);
      border-radius: 28px;
      margin: 18px 20px;
      overflow: hidden;
      .draw_status {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.3);
        z-index: 1;
        border-radius: 10px;
        .status_img {
          width: 220px;
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          top: 320px;
        }
      }
      .img_center {
        width: 368px;
        height: 275px;
        background: #393939;
        border-radius: 8px;
        margin: 16px;
        overflow: hidden;
        .goods_image {
          display: inline-block;
        }
      }
      .video_gift {
        .goods_image {
          width: 100%;
          height: 100%;
        }
      }
      .ebook_gift {
        text-align: center;
        .goods_image {
          width: 194px;
          height: 254px;
          margin-top: 10px;
        }
      }
      .vip_gift {
        text-align: center;
        .goods_image {
          width: 230px;
          margin-top: 60px;
        }
      }
      .gift_title {
        font-weight: 400;
        font-size: 16px;
        color: #fff5e0;
        margin: 0 16px;
        display: flex;
        align-items: center;
        height: 48px;
        h3 {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
        }
      }
      .price {
        font-weight: 500;
        font-size: 16px;
        color: #fd5a52;
        text-align: center;
        margin-top: 10px;
      }
    }
    .card_bottom {
      position: absolute;
      bottom: 0;
      z-index: 2;
      .tip_txt {
        font-weight: 400;
        font-size: 16px;
        color: #7d7d7d;
        text-align: center;
        position: absolute;
        top: 48px;
        width: 100%;
        text-align: center;
      }
      .draw_btn {
        position: absolute;
        top: 168px;
        left: 0;
        right: 0;
        text-align: center;
        z-index: 4;
        .btn_center {
          display: inline-block;
          min-width: 250px;
          height: 32px;
          padding: 0 20px;
          background: linear-gradient(0deg, #ee6b36 0%, #f3ae57 99%);
          border-radius: 20px;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          text-align: center;
          line-height: 32px;
          margin: 0 auto;
          cursor: pointer;
          transition: all 0.3s;
          &:hover {
            opacity: 0.6;
          }
        }
        .error_btn {
          background: #cccccc;
          color: #ffffff;
        }
      }
      .base_map {
        background-image: url('@/assets/images/baseMap.png');
        background-size: cover;
        width: 436px;
        height: 136px;
        left: 0px;
      }
      .base_bottom {
        width: 436px;
        height: 91px;
        background: linear-gradient(120deg, #f6ead9 0%, #f0d7ba 100%);
        border-radius: 8px;
      }
    }

    .change_carousel {
      font-size: 46px;
      color: #e9e9e9;
      position: absolute;
      top: 240px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        opacity: 0.6;
      }
    }
    .left {
      left: 28px;
    }
    .right {
      right: 24px;
    }
    .close_wrap {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -76px;
      text-align: center;
      .close {
        font-size: 34px;
        color: #ffffff;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          opacity: 0.6;
        }
      }
    }
    .tip_txt {
      position: absolute;
      top: 592px;
      font-weight: 400;
      font-size: 16px;
      color: #ef733a;
      text-align: center;
      width: 436px;
    }
    .indicator_list {
      position: absolute;
      top: 560px;
      left: 0;
      right: 0;
      margin: 0 auto;
      text-align: center;
      li {
        width: 10px;
        height: 10px;
        background: #ffffff;
        border-radius: 7px;
        display: inline-block;
        margin: 0 9px;
        .indicator_active {
          width: 3px;
          height: 3px;
          background: #ef793d;
          border-radius: 50%;
          margin: 1.5px;
        }
      }
      .active {
        border: 2px solid #ef793d;
      }
    }
  }
}

.bg-box {
  position: absolute;
  left: 0;
  top: 60px;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  display: flex;
}

.box-1,
.box-2,
.box-3,
.box-4 {
  flex: none;
  position: absolute;
  top: 0;
  height: 643px;
  width: 110px;
  background: transparent;
  border-radius: 10px;
}

.box-1 {
  left: 0px;
}

.box-2 {
  left: 126px;
}

.box-3 {
  left: 248px;
}

.box-4 {
  left: 370px;
}

.img-box {
  position: relative;
  z-index: 0;
}
</style>
